import React from 'react';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const { t } = useTranslation();

  return (
    <div>
      {t('login.title')}
      <br />
      {t('login.welcome')}
    </div>
  );
};

Login.propTypes = {};

export default Login;
